import {
	ADD_CATEGORY_FEATURE,
	SET_CATEGORY_FEATURES,
	UPDATE_CATEGORY_FEATURE,
	SET_ACTIVE_CATEGORY_FEATURE,
	SET_FILE_LIST,
	SET_CLASS_NAME,
	SET_STYLE_SHEET,
	SET_CATEGORY,
	DELETE_CATEGORY_FEATURE,
	SET_BRANDS,
	SET_NAME,
	SET_ORDER,
	UPDATE_CATEGORY_FEATURE_VALUE,
	TOGGLE_CATEGORY_FEATURE_ACTIVE
} from '../actions/types';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const defaultState = {
	activeCategoryFeature: {
		fileList: [],
		styleSheet: ''
	},
	data: [],
	loading: false
}

export const categoryFeatureReducer = ( state = defaultState, action ) => {

	switch( action.type ){

		case `${ADD_CATEGORY_FEATURE}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${ADD_CATEGORY_FEATURE}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${ADD_CATEGORY_FEATURE}_${FULFILLED}`:
			
			return {
				...state,
				data: [
					...state.data,
					action.payload.data.categoryFeature
				],
				loading: false
			}

		case `${SET_CATEGORY_FEATURES}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${SET_CATEGORY_FEATURES}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${SET_CATEGORY_FEATURES}_${FULFILLED}`:
			
			return {
				...state,
				data: action.payload.data.categoryFeatures,
				loading: false
			}

		case `${UPDATE_CATEGORY_FEATURE}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${UPDATE_CATEGORY_FEATURE}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${UPDATE_CATEGORY_FEATURE}_${FULFILLED}`:
			
			return {
				...state,
				data: state.data.map( _categoryFeature => {

					if( _categoryFeature._id === action.payload.data.categoryFeature._id ){
						return action.payload.data.categoryFeature
					}

					return _categoryFeature
				}),
				loading: false
			}
		
		case `${UPDATE_CATEGORY_FEATURE_VALUE}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${UPDATE_CATEGORY_FEATURE_VALUE}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${UPDATE_CATEGORY_FEATURE_VALUE}_${FULFILLED}`:
			
			return {
				...state,
				data: state.data.map( _categoryFeature => {

					if( _categoryFeature._id === action.payload.data.categoryFeature._id ){
						return action.payload.data.categoryFeature
					}

					return _categoryFeature
				}),
				loading: false
			}

		case `${TOGGLE_CATEGORY_FEATURE_ACTIVE}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${TOGGLE_CATEGORY_FEATURE_ACTIVE}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${TOGGLE_CATEGORY_FEATURE_ACTIVE}_${FULFILLED}`:
			
			return {
				...state,
				data: state.data.map( _categoryFeature => {

					if( _categoryFeature._id === action.payload.data.categoryFeature._id ){
						return action.payload.data.categoryFeature
					}

					return _categoryFeature
				}),
				loading: false
			}


		case `${SET_ACTIVE_CATEGORY_FEATURE}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${SET_ACTIVE_CATEGORY_FEATURE}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${SET_ACTIVE_CATEGORY_FEATURE}_${FULFILLED}`:
			
			return {
				...state,
				activeCategoryFeature: action.payload.data.categoryFeature,
				loading: false
			}

		case SET_FILE_LIST:
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					fileList: action.fileList
				}
			}

		case SET_CLASS_NAME:
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					fileList: state.activeCategoryFeature.fileList.map( _file => {

						if( _file.uid === action.fileId ){
							_file.className = action.className
						}

						return _file
					})
				}
			}

		case SET_ORDER:
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					fileList: state.activeCategoryFeature.fileList.map( _file => {

						if( _file.uid === action.fileId ){
							_file.order = action.order
						}

						return _file
					})
				}
			}
	
		case SET_STYLE_SHEET:
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					styleSheet: action.styleSheet
				}
			}

		case SET_CATEGORY:
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					fileList: state.activeCategoryFeature.fileList.map( _file => {

						if( _file.uid === action.fileId ){
							_file.category = action.category
						}

						return _file
					}),
					brands: []
				}
			}

		case SET_BRANDS:
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					brands: action.brands
				}
			}

		case SET_NAME: 
			return {
				...state,
				activeCategoryFeature: {
					...state.activeCategoryFeature,
					name: action.name
				}
			}

		case `${DELETE_CATEGORY_FEATURE}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${DELETE_CATEGORY_FEATURE}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${DELETE_CATEGORY_FEATURE}_${FULFILLED}`:
			
			return {
				...state,
				data: state.data.filter( _categoryFeature => _categoryFeature._id !== action.payload.data.categoryFeatureId ),
				loading: false
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/category-feature/reducers/index.js